import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePreview } from './components/InsidePreview';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
type AppProps = {
  showCountdownBar?: boolean;
  showBonuses?: boolean;
};
export function App({
  showCountdownBar = true,
  showBonuses = true
}: AppProps) {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="3ik7ekc2063oj">
      <MetaPixel data-id="element-1" data-mp="3ij65ue8glt9z" />
      <UtmifyScript data-id="element-2" data-mp="3ijpe138b53at" />
      {showCountdownBar && <CountdownBar data-id="element-3" data-mp="3ml14tc2x3ukl" />}
      <main data-id="element-4" data-mp="3mkhn9wh6j873">
        <Hero data-id="element-5" data-mp="3mk83wrqn3zad" />
        <StatsBar data-id="element-6" data-mp="3mjq3rk0ux0x6" />
        <Difference data-id="element-7" data-mp="3mj6jhwnqi0fz" />
        <Recognize data-id="element-8" data-mp="3rbr9en3irte8" />
        <WhatsInside data-id="element-9" data-mp="3rdapodp6e4g0" />
        <InsidePreview data-id="element-10" data-mp="3rcswxr1q28cu" />
        <InstantAccess data-id="element-11" data-mp="3relumgucxi8p" />
        {showBonuses && <Bonuses data-id="element-12" data-mp="680tswt8a8y" />}
        <Offer data-id="element-13" data-mp="4n6a3ahwrb3" />
        <Guarantee data-id="element-14" data-mp="56n1goet9nj" />
        <Testimonials data-id="element-15" data-mp="7st1bvnjh3n" />
        <Faq data-id="element-16" data-mp="2zllf11m4wkmq" />
      </main>
      <Footer data-id="element-17" data-mp="2zm4v0cs84yy4" />
    </div>;
}